const footerTwoCode = `// Material Kit 2 PRO React examples
import DefaultFooter from "examples/Footers/DefaultFooter";

// routes
import footerRoutes from "footer.routes";

function FooterTwo() {
  return <DefaultFooter content={footerRoutes} />;
}

export default FooterTwo;`;

export default footerTwoCode;
